import microuniversoApi from "app/api/microuniversoApi"
import { useAppSelector } from "app/redux/hooks"
import { IItemOrcamento } from "app/types/IItemOrcamento"
import { IOrcamento } from "app/types/IOrcamento"
import { tratamentoErroPadrao } from "app/use-cases"
import { Dict } from "app/utils/Dict"
import globalMU from "globalMU"

import React, { useEffect, useRef, useState } from "react"
import { Breadcrumb2Container } from "../breadcrumb2/Breadcrumb2Container"
import { useMenuConsultaProduto } from "../menu-consulta-produtos/useMenuConsultaProduto"
import { renderizarComponentReact } from "../renderizarOuRemoverComponentReact"
import { DadosUltimasCompras, FiltroUltimasComprasProdutos, UltimasComprasProdutos } from "./UltimasComprasProdutos"

export type UltimasComprasProdutoContainerProps = {
    item: IItemOrcamento,
    onRemover: () => void,
    onVoltar: () => void,
    passos: Dict<string, () => void>,
    foraOrcamento: boolean
}

export const UltimasComprasProdutoContainer = (props: UltimasComprasProdutoContainerProps) => {
    const orcamento: IOrcamento = useAppSelector((store) => store.orcamento)
    const [dadosUltimasCompras, setDadosUltimasCompras] = useState<DadosUltimasCompras[]>([])

    const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))
    useMenuConsultaProduto(new Dict(Object.assign({}, props.passos.map)), props.onVoltar, props.item, props.foraOrcamento)

    const onObterUltimasCompras = async () => {
        try {
            globalMU.blockUI()

            if (orcamento.CodigoCliente <= 7) {
                globalMU.showInfoMessage("Selecione um cliente antes de consultar última compra.");
                onVoltar()
                return;
            }

            const filtro = { CodigoCliente: orcamento.CodigoCliente, CodigoFilial: orcamento.CodigoFilialOrcamento, CodigosProdutos: [props.item.Codigo] } as FiltroUltimasComprasProdutos
            const resposta = await microuniversoApi.Produto.ultimasComprasProduto(filtro)

            if (resposta.length == 0) {
                globalMU.showWarnMessage("O(s) produto(s) não possui(em) última(s) compra(s).");
                onVoltar()
                return;
            }

            setDadosUltimasCompras(resposta)
        } catch (e) {
            tratamentoErroPadrao(e)
            onVoltar()
        } finally {
            globalMU.unblockUI()
        }
    }

    const onVoltar = () => {
        props.onRemover()
        props.onVoltar()
    }

    const onPassoSelecionado = (passo: string) => {
        props.onRemover()
        props.passos.get(passo)()
    }

    useEffect(() => {
        passosInterno.current.set("Última Compra",() => { renderizarComponentReact(<UltimasComprasProdutoContainer {...props} />, "conteudo-pagina", true)  })
        onObterUltimasCompras()
    }, [])

    return (
        <>
            <Breadcrumb2Container
                passos={passosInterno.current.keysToList()}
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                id="UltimasComprasProdutoContainer"
                onBotaoVoltarClicado={onVoltar}
                onPassoSelecionado={onPassoSelecionado}

            />
            <UltimasComprasProdutos dadosUltimasCompras={dadosUltimasCompras} />
        </>
    )
}   